import { Injectable } from '@angular/core';
import { API_PATH } from '@app/app.constants';

import { Observable } from 'rxjs/internal/Observable';
import { APIService } from '@app/_services/api.service';

@Injectable({
    providedIn: 'root'
})
export class MainAnalyticsService {
    constructor(private api: APIService) {}

    getStudentLessonData(lessonId: number): Observable<any> {
        const url = `${API_PATH.main_analytics.student_lesson_data}${lessonId}/`;
        return this.api.get(url);
    }

    getSimpleLessonsInfo(): Observable<any> {
        const url = `${API_PATH.main_analytics.student_simple_lessons_info}`;
        return this.api.get(url);
    }

    getLessonCardsResults(lessonId: number, userId: number): Observable<any> {
        const url = `${API_PATH.main_analytics.student_lesson_cards_results}${lessonId}/${userId}`;
        return this.api.get(url);
    }
}
